import React from 'react';
import moment from 'moment-timezone';
import ReplayContext from './ReplayContext';
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider';
import { SliderRail, Handle, Track, Tick } from '../../widgets/Slider';
import { Row, Col } from 'react-bootstrap';
import {
    STREAM_FETCHING, STREAM_FETCHED, EVENT_PLAYING, EVENT_STOP,
    EVENT_PAUSE, EVENT_LIVE_STREAM, EVENT_CLEAR_STREAM, EVENT_PLAY
} from './GPSPlayer';

const PLAYER = "player";
export default class Player extends React.Component {
    static contextType = ReplayContext;

    constructor() {
        super();

        this.defaultState = {
            isPlaying: false,
            disablePlay: true,
            domain: [0, 1],
            values: [0],
            reversed: false,
            tickValues: [0, 1],
            leftDuration: 0,
            boundsCount: 0,
            update: [0]
        };

        this.gpsPlayer = null;
        this.state = { ...this.defaultState };
        this.handlePlay = this.handlePlay.bind(this);
    };

    componentDidMount() {
        if (this.context.mapMarker) this.context.mapMarker.hideMarkers();
        this.gpsPlayer = this.context.gpsPlayer;

        const me = this;
        this.gpsPlayer.addListener(STREAM_FETCHING, PLAYER, () => {
            me.setState({ ...me.defaultState });
        }).addListener(STREAM_FETCHED, PLAYER, ({ start, end }) => {
            if (start === me.state.domain[0] && end === me.state.domain[1]) return;
            if (!(start && end) || (start === end)) return me.setState({ ...me.defaultState });
            me.setState({
                ...me.defaultState,
                domain: [start, end], tickValues: [start, end], disablePlay: false
            });
        }).addListener(EVENT_PLAY, PLAYER, () => {
            me.setState({ isPlaying: true });
        }).addListener(EVENT_PLAYING, PLAYER, ({ leftDuration, progressTime }) => {
            if (me.state.leftDuration === leftDuration) return;
            me.setState({ values: [progressTime], leftDuration });
        }).addListener(EVENT_PAUSE, PLAYER, () => {
            me.setState({ isPlaying: false });
        }).addListener(EVENT_STOP, PLAYER, () => {
            me.setState({ isPlaying: false });
        }).addListener(EVENT_LIVE_STREAM, PLAYER, ({ end }) => {
            me.setState({
                domain: [me.state.domain[0], end],
                tickValues: [me.state.tickValues[0], end],
            });
        }).addListener(EVENT_CLEAR_STREAM, PLAYER, () => {
            me.setState({ ...me.defaultState });
        });
    }

    handlePlay() {
        if (!this.state.isPlaying) {
            if (this.state.boundsCount === 0 && this.props.isAutoZoom) this.gpsPlayer.setBounds();
            this.gpsPlayer.play();
            if (this.state.boundsCount === 0 && this.props.isAutoZoom)
                this.setState({ boundsCount: this.state.boundsCount + 1 });
        }
        else this.gpsPlayer.pause();
    }

    setScale = (minRange, maxRange) => {
        this.setState({
            domain: [minRange, maxRange],
            tickValues: [minRange, maxRange],
            values: [0], isPlaying: false
        });
    }

    getTickInterval = (minRange, maxRange) => {
        return [minRange, maxRange];
    }

    onUpdate = update => {
        this.setState({ update });
    }

    onChange = values => {
        if (values[0] > 0 && values[0] !== this.state.values[0]) {
            this.gpsPlayer.skip(values[0]);
            if (this.state.isPlaying) this.gpsPlayer.play();
        };

        if (values[0] <= this.state.tickValues[0]) this.setState({ leftDuration: 0, values: [this.state.tickValues[0]] });
        else this.setState({ values });
    }

    setDomain = domain => {
        this.setState({ domain });
    }

    formatTicks = value => {
        if (this.state.domain.length === 0 || this.state.domain[1] <= 1) return '00:00';
        const diffHours = this.props.dateRange.end.diff(this.props.dateRange.start, "hours");
        return moment.utc(value).tz(this.props.timezone)
            .format(diffHours > 24 ? "DD MMM hh:mm:ss a" : "hh:mm:ss a");
    }

    playerDuration = milliSeconds => {
        const pad = (num, size) => ('000' + num).slice(size * -1);

        const time = parseFloat(milliSeconds / 1000).toFixed(3),
            hours = Math.floor(time / 60 / 60),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60);

        return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
    }

    handleSkip(type) {
        const isPlaying = this.state.isPlaying;
        const startTime = this.state.tickValues[0];
        const progressTime = moment.utc(this.state.values[0]);
        const time = (type === "forward") ?
            progressTime.add(15, "seconds").valueOf() :
            progressTime.subtract(15, "seconds").valueOf();

        this.gpsPlayer.skip(time);
        if (isPlaying) this.gpsPlayer.play();

        if (time <= startTime) this.setState({ isPlaying, leftDuration: 0, values: [startTime] });
        else this.setState({ isPlaying });
    }

    componentWillUnmount() {
        this.gpsPlayer.removeListenerByName(PLAYER);
    }

    render() {
        const { state: { isPlaying, disablePlay, domain, values, reversed, tickValues, leftDuration } } = this;

        return <Row className="mx-0 player-row pr-2">
            <Col md={12} className="px-0">
                <div className="d-flex">
                    <div className="play-control">
                        <button onClick={() => this.handleSkip("backward")} disabled={disablePlay ? true : (values[0] <= tickValues[0])}
                            title="Backward" className="btn-backward">
                            <i className="fa fa-lg fa-backward" />
                        </button>
                        <button onClick={this.handlePlay} disabled={disablePlay} title={!isPlaying ? 'Play' : 'Pause'}>
                            <i className={`fa fa-lg ${!isPlaying ? 'fa-play' : 'fa-pause'}`} />
                        </button>
                        <button onClick={() => this.handleSkip("forward")} disabled={disablePlay ? true : (values[0] >= tickValues[1])}
                            title="Forward" className="btn-forward">
                            <i className="fa fa-lg fa-forward" />
                        </button>
                    </div>
                    <div className="flex-grow-1">
                        <PlaySlider
                            disabled={(domain.length > 0 && domain[1] === 1) || disablePlay}
                            domain={domain}
                            reversed={reversed}
                            tickValues={tickValues}
                            values={values}
                            onUpdate={this.onUpdate}
                            onChange={this.onChange}
                            formatTicks={this.formatTicks} />
                    </div>
                    <div className="duration">
                        <span className="text">{!(domain.length > 0 && domain[1] === 1) ?
                            this.playerDuration(leftDuration) : '00:00:00'}</span>
                    </div>
                </div>
            </Col>
        </Row>;
    }
}

const PlaySlider = ({ disabled, step, domain, values, tickValues, formatTicks, onUpdate, onChange }) => (
    <Slider
        {...disabled ? { disabled: true } : {}}
        mode={1}
        step={step || 1}
        domain={domain}
        values={values}
        onUpdate={onUpdate}
        onChange={onChange}
        className="player-slider">
        <Rail>
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
        </Rail>
        <Handles>
            {({ handles, getHandleProps }) => (
                <div className="slider-handles">
                    {handles.map(handle => (
                        <Handle
                            key={handle.id}
                            handle={handle}
                            domain={domain}
                            getHandleProps={getHandleProps}
                        />
                    ))}
                </div>
            )}
        </Handles>
        <Tracks right={false}>
            {({ tracks, getTrackProps }) => (
                <div className="slider-tracks">
                    {tracks.map(({ id, source, target }) => (
                        <Track
                            key={id}
                            source={source}
                            target={target}
                            getTrackProps={getTrackProps}
                        />
                    ))}
                </div>
            )}
        </Tracks>
        <Ticks values={tickValues}>
            {({ ticks }) => (
                <div className="slider-ticks">
                    {ticks.map((tick, i) => {
                        return <Tick key={i} tick={tick} count={ticks.length} format={formatTicks} />
                    })}
                </div>
            )}
        </Ticks>
    </Slider>
);